import "flatpickr/dist/flatpickr.min.css";
import Flatpickr from "react-flatpickr";

interface OrderFilterBarProps {
  startDate: Date;
  endDate: Date;
  loading: boolean;
  onStartDateChange: (date: Date) => void;
  onEndDateChange: (date: Date) => void;
  onSearch: (e: React.FormEvent) => void;
}

function OrderFilterBar({ startDate, endDate, loading, onStartDateChange, onEndDateChange, onSearch }: OrderFilterBarProps) {
  return (
    <form onSubmit={onSearch}>
      <div
        className="p-3 rounded-3 mb-4 d-flex flex-wrap align-items-end gap-3"
        style={{ background: '#f8faff', border: '1.5px solid #e0eaff' }}
      >
        {/* Başlangıç tarihi */}
        <div>
          <label className="form-label small fw-semibold mb-1 text-muted d-block">
            <i className="bi bi-calendar-event me-1"></i>Başlangıç
          </label>
          <Flatpickr
            id="order-start-date"
            value={startDate}
            onChange={(dates) => dates[0] && onStartDateChange(dates[0])}
            options={{ dateFormat: "d-m-Y", maxDate: "today", disableMobile: true }}
            className="form-control"
            style={{ borderRadius: '10px', border: '1.5px solid #dee2e6', minWidth: '150px', fontSize: '0.9rem' }}
          />
        </div>

        {/* Bitiş tarihi */}
        <div>
          <label className="form-label small fw-semibold mb-1 text-muted d-block">
            <i className="bi bi-calendar-event me-1"></i>Bitiş
          </label>
          <Flatpickr
            id="order-end-date"
            value={endDate}
            onChange={(dates) => dates[0] && onEndDateChange(dates[0])}
            options={{
              dateFormat: "d-m-Y",
              maxDate: new Date(new Date().setDate(new Date().getDate() + 1)),
              disableMobile: true,
            }}
            className="form-control"
            style={{ borderRadius: '10px', border: '1.5px solid #dee2e6', minWidth: '150px', fontSize: '0.9rem' }}
          />
        </div>

        {/* Ara butonu */}
        <button
          type="submit"
          className="btn"
          disabled={loading}
          style={{
            background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
            color: '#fff',
            borderRadius: '10px',
            fontWeight: 600,
            padding: '8px 24px',
            border: 'none',
            boxShadow: '0 3px 10px rgba(59,130,246,0.3)',
          }}
        >
          {loading
            ? <><span className="spinner-border spinner-border-sm me-2" role="status" />Yükleniyor...</>
            : <><i className="bi bi-search me-1"></i>Ara</>}
        </button>
      </div>
    </form>
  );
}

export default OrderFilterBar;